import React from 'react';
import { useDispatch } from 'react-redux';
import { PasswordResetError } from '../../../../errors/passwordResetError';
import { IThunkDispatch } from '../../../../store/middleware';
import { IState } from '../../../../store/reducer';
import { requestPasswordReset } from './actions';
import { ResetPasswordComponent } from './ResetPassword';

import { useSelector } from 'react-redux';
import { NavigateFunction, useNavigate } from 'react-router-dom';

const mapStateToProps = (state: IState) => {
	return {
		failure: !state.views.login.valid,
		error: (state.views.login.resetPassword.error || {} as PasswordResetError),
		loading: state.views.login.resetPassword.loading,
	};
};

const mapDispatchToProps = (dispatch: IThunkDispatch, navigate: NavigateFunction) => ({
	onSubmit: async (email: string) => {
		dispatch(requestPasswordReset(email, navigate));
	}
});

export const ResetPassword = () => {
	const navigate = useNavigate();
	const props = {
		...useSelector(mapStateToProps),
		...mapDispatchToProps(useDispatch(), navigate)
	};

	return (
		<ResetPasswordComponent {...props}/>
	);
};
